import { render } from "./OwnedStorySellPriceDialog.vue?vue&type=template&id=5d2f52bc"
import script from "./OwnedStorySellPriceDialog.vue?vue&type=script&lang=js"
export * from "./OwnedStorySellPriceDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__